(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const hero = document.querySelector('hero-video, .hero-video-section, .section-hero-video');
      let threshold = 350;
      if (hero) {
        const heroHeight = hero.offsetHeight;
        const heroTop = hero.offsetTop || 0;
        threshold = Math.min(heroTop + heroHeight - 90, Math.max(heroTop + Math.floor(heroHeight * 0.5), 320));
      }

      if (scrollTop > threshold) {
        this.header.classList.add('is-sticky-active', 'shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.remove('is-sticky-active', 'shopify-section-header-sticky', 'shopify-section-header-hidden');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.reveal();
    }

    reveal() {
      this.header.classList.add('is-sticky-active', 'shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'is-sticky-active');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function initStickyHeroScroll() {
      const headerSection = document.getElementById('shopify-section-header');
      if (!headerSection) return;

      let ticking = false;
      function checkScroll() {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const hero = document.querySelector('hero-video, .hero-video-section, .section-hero-video');
            let threshold = 350;
            if (hero) {
              const heroHeight = hero.offsetHeight;
              const heroTop = hero.offsetTop || 0;
              threshold = Math.min(heroTop + heroHeight - 90, Math.max(heroTop + Math.floor(heroHeight * 0.5), 320));
            }

            if (scrollTop > threshold) {
              if (!headerSection.classList.contains('is-sticky-active')) {
                headerSection.classList.add('is-sticky-active', 'shopify-section-header-sticky');
                headerSection.classList.remove('shopify-section-header-hidden');
              }
            } else {
              if (headerSection.classList.contains('is-sticky-active')) {
                headerSection.classList.remove('is-sticky-active', 'shopify-section-header-sticky');
              }
            }
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', checkScroll, { passive: true });
      window.addEventListener('resize', checkScroll, { passive: true });
      checkScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyHeroScroll);
    } else {
      initStickyHeroScroll();
    }
  })();
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        inputLanguage: this.querySelector('input[name="language_code"], input[name="locale_code"]'),
        inputCountry: this.querySelector('input[name="country_code"]'),
        button: this.querySelector('button.header-localization__button, button.disclosure__button, button'),
        panel: this.querySelector('.header-localization__panel, .disclosure__list-wrapper'),
        form: this.querySelector('form')
      };

      if (!this.elements.button || !this.elements.panel) return;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onItemClick = this.onItemClick.bind(this);
      this.toggleSelector = this.toggleSelector.bind(this);
      this.onWindowWheel = this.onWindowWheel.bind(this);
      this.onWindowTouchMove = this.onWindowTouchMove.bind(this);

      this.elements.button.addEventListener('click', this.toggleSelector);
      this.addEventListener('keydown', this.onKeyDown);

      this.querySelectorAll('[data-value]').forEach(item => {
        item.addEventListener('click', this.onItemClick);
      });

      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('wheel', this.onWindowWheel, { capture: true });
      window.removeEventListener('touchmove', this.onWindowTouchMove);
    }

    isOpen() {
      return this.elements.button && this.elements.button.getAttribute('aria-expanded') === 'true';
    }

    hidePanel() {
      if (!this.isOpen()) return;
      this.elements.panel.setAttribute('hidden', '');
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');

      window.removeEventListener('wheel', this.onWindowWheel, { capture: true });
      window.removeEventListener('touchmove', this.onWindowTouchMove);
    }

    openSelector() {
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');

      window.addEventListener('wheel', this.onWindowWheel, { passive: false, capture: true });
      window.addEventListener('touchmove', this.onWindowTouchMove, { passive: false });

      requestAnimationFrame(() => {
        const activeCurrency = this.elements.panel.querySelector('.header-localization__list--currency .is-active');
        if (activeCurrency) {
          activeCurrency.scrollIntoView({ block: 'nearest' });
        }
      });

      const activeOption = this.elements.panel.querySelector('.is-active, [aria-current="true"]') || this.elements.panel.querySelector('button, a');
      if (activeOption) activeOption.focus({ preventScroll: true });
    }

    onWindowWheel(event) {
      if (!this.isOpen()) return;

      if (this.elements.panel && this.elements.panel.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        const currencyList = this.elements.panel.querySelector('.header-localization__list--currency');
        if (currencyList) {
          currencyList.scrollTop += event.deltaY;
        }
      } else {
        this.hidePanel();
      }
    }

    onWindowTouchMove(event) {
      if (!this.isOpen()) return;

      if (this.elements.panel && this.elements.panel.contains(event.target)) {
        const currencyList = this.elements.panel.querySelector('.header-localization__list--currency');
        if (!currencyList || !currencyList.contains(event.target)) {
          event.preventDefault();
        }
      } else {
        this.hidePanel();
      }
    }

    toggleSelector(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.isOpen()) {
        this.hidePanel();
        this.elements.button.focus();
      } else {
        this.openSelector();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
        this.elements.button.focus();
        return;
      }

      if (this.isOpen()) {
        const focusable = Array.from(this.elements.panel.querySelectorAll('button:not([disabled]), a:not([disabled])'));
        const index = focusable.indexOf(document.activeElement);

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          const nextIndex = (index + 1) % focusable.length;
          focusable[nextIndex].focus();
          focusable[nextIndex].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          const prevIndex = (index - 1 + focusable.length) % focusable.length;
          focusable[prevIndex].focus();
          focusable[prevIndex].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Tab') {
          setTimeout(() => {
            if (!this.contains(document.activeElement)) {
              this.hidePanel();
            }
          }, 10);
        }
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const type = target.dataset.type;
      const value = target.dataset.value;

      if (type === 'language') {
        if (this.elements.inputLanguage) {
          this.elements.inputLanguage.value = value;
        }
      } else if (type === 'country') {
        if (this.elements.inputCountry) {
          this.elements.inputCountry.value = value;
        }
      } else {
        if (this.elements.inputLanguage && value.length === 2 && ['en', 'ar'].includes(value.toLowerCase())) {
          this.elements.inputLanguage.value = value;
        } else if (this.elements.inputCountry) {
          this.elements.inputCountry.value = value;
        }
      }

      if (this.elements.form) {
        this.elements.form.submit();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        if (!this.dataset.url) return;

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              const newSlides = recommendations.querySelectorAll('.swiper-slide');
              if (newSlides.length > 0) {
                this.innerHTML = recommendations.innerHTML;
                if (typeof window.initLuxuryCardSliders === 'function') {
                  window.initLuxuryCardSliders();
                }
                const slider = this.querySelector('recommendation-slider');
                if (slider && typeof slider.init === 'function') {
                  slider.init();
                }
              }
            }

            this.classList.add('product-recommendations--loaded');
          })
          .catch(e => {
            console.error('Recommendations fetch error:', e);
            this.classList.add('product-recommendations--loaded');
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
